module.exports = __webpack_public_path__ + "static/media/download-icon.1ae0e874.svg";